import { render, staticRenderFns } from "./NuvaCoins.vue?vue&type=template&id=48804a8e&scoped=true"
import script from "./NuvaCoins.vue?vue&type=script&lang=js"
export * from "./NuvaCoins.vue?vue&type=script&lang=js"
import style0 from "./NuvaCoins.vue?vue&type=style&index=0&id=48804a8e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48804a8e",
  null
  
)

export default component.exports